export default __webpack_public_path__ + "static/travel-a30f2adac67cd40c803b296d340e12d1.png";